// extracted by mini-css-extract-plugin
export default {"btnContainer":"SsfXNeM2VkQa309unLr2SA==","activateButton":"JbJW0jS4KNj+TDBj7nAa8w==","notNowButton":"_2vk10HaC+ocAtgA+z2up0w=="};